import /*Vue, */{ createApp } from 'vue'
import App from './App.vue'
import UIkit from 'uikit'
import '@/assets/styles/styles.scss'
import Icons from 'uikit/dist/js/uikit-icons'
import router from './router'
import store from './store'

// Vue.configureCompat({ WATCH_ARRAY: false });

UIkit.use(Icons)
window.UIkit = UIkit

// Vue.config.productionTip = false

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

const app = createApp(App);
//this does https://alligator.io/vuejs/creating-custom-plugins/ , i.e. variables starting with $ exist now in every instance
app.use(router);
app.use(store);
app.mount('#app');

